import styled from "styled-components";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import "swiper/css";
import {useRef} from "react";
import { TbChevronLeft } from "react-icons/tb";
import { TbChevronRight } from "react-icons/tb";
import {SIZES} from "@/components/constants";
import {useMediaQuery} from "react-responsive";


const DeliverySwiperContent = ({items}) => {
    const isTablet = useMediaQuery(
        { query: `(max-width: ${SIZES.TABLET})` },
        undefined,
        () => false
    );
    const originDataCount = 3;
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const paginationRef = useRef(null);
    return(
        <SwiperArea>
            <div className={"swipe-container"}>
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    loop={true}
                    slidesPerView={isTablet? 1.8 : 3}
                    centeredSlides={true}
                    loopAdditionalSlides={originDataCount}
                    className="swiper"
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}

                    onBeforeInit={(swiper) => {
                        swiper.params.navigation.prevEl = prevRef.current;
                        swiper.params.navigation.nextEl = nextRef.current;
                        swiper.params.pagination.el = paginationRef.current;
                    }}
                    onInit={(swiper) => {
                        swiper.pagination.init();
                        swiper.pagination.render();
                        swiper.pagination.update();
                    }}
                    navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                    }}

                    pagination={{
                        el: paginationRef.current,
                        clickable: true,
                        renderBullet: (index, className) => {
                            if (index >= originDataCount) return "";
                            return `<span class="${className}" data-index="${index}"></span>`;
                        },
                    }}
                    onSlideChange={(swiper) => {
                        if (!swiper.pagination?.el) return;
                        const bullets = swiper.pagination.el.querySelectorAll(".swiper-pagination-bullet");
                        const activeIndex = swiper.realIndex % originDataCount;
                        bullets.forEach((b, i) => {
                            if (i === activeIndex) {
                                b.classList.add("swiper-pagination-bullet-active");
                            } else {
                                b.classList.remove("swiper-pagination-bullet-active");
                            }
                        });
                    }}
                >
                    {items.map((v, i) => (
                        <SwiperSlide key={i}>
                            <div className="slide-inner">
                                <img src={v} alt={`${i}`} />
                            </div>
                        </SwiperSlide>
                    ))}

                    <div ref={prevRef} className={"swiper-button-prev"}><TbChevronLeft size={25} color={"#fff"}/></div>
                    <div ref={nextRef} className={"swiper-button-next"}><TbChevronRight size={25} color={"#fff"}/></div>
                    <div ref={paginationRef} className={"swiper-pagination"} />
                </Swiper>
            </div>
        </SwiperArea>
    )
}

const SwiperArea = styled.div`
    width: 100%;
    .swipe-container{
        position: relative;
        width: 100%;
        margin: 0 auto;
        height: 100%;
        display: flex;
        align-items: center;

        .swiper {
            position: relative;
            width: 100%;
            overflow: hidden;
            padding: 0 0 20px;
            .swiper-slide {
                position: relative;
                flex-shrink: 0;
                opacity: .5;
                transform: scale(.7);
                transition: all .3s ease-in-out;
                overflow: hidden;
                border-radius: 0.4285rem;
                &.swiper-slide-active {
                    transform: scale(1) !important;
                    opacity: 1 !important;
                }
            }
            .swiper-button-next,
            .swiper-button-prev{
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                width: 40px;
                height: 40px;
                background-color: rgba(0, 0, 0, .4);
                border-radius: 50%;
                display: none;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                z-index: 10;
                svg{
                    fill: transparent;
                }
            }
            .swiper-button-prev{
                left: 20px;
            }
            .swiper-button-next{
                right: 20px;
            }
            .swiper-pagination{
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 0;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 7px;
                z-index: 10;
                .swiper-pagination-bullet{
                    pointer-events: none;
                    width: 9px;
                    height: 9px;
                    border-radius: 50%;
                    background-color: rgba(0, 0, 0, .4);
                    &.swiper-pagination-bullet-active{
                        background-color: #07903a;
                    }
                }
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE}) {
        .swipe-container {
            max-width: none;
        }
    }

    @media (min-width: ${SIZES.MOBILE_L}) {
        .swipe-container {
            max-width: 768px;
            .swiper {
                .swiper-button-next,
                .swiper-button-prev{
                    display: none;
                }
            }
        }
    }

    @media (min-width: ${SIZES.TABLET}) {
        .swipe-container {
            max-width: 1024px;
            .swiper {
                padding: 0 20px 40px;
            }
        }
    }

    @media (min-width: ${SIZES.TABLET_L}) {
        .swipe-container {
            max-width: 1130px;
            .swiper {
                .swiper-button-next,
                .swiper-button-prev{
                    display: flex;
                }
            }
        }
    }

    @media screen and (min-width: ${SIZES.PC}) {
        .swipe-container{
            max-width: 1280px;
        }
    }
`

export default DeliverySwiperContent